import styled from '@emotion/styled';
import RSFormFeedback, {
  FormFeedbackProps as RSFormFeedbackProps,
} from 'reactstrap/lib/FormFeedback';

export type FormFeedbackProps = RSFormFeedbackProps;

const FormFeedback = styled(RSFormFeedback)<FormFeedbackProps>`
  margin: 4px 0;

  color: ${({ theme }) => theme.default.colors.Feedback.Error};

  font-size: 14px;
  line-height: 20px;
`;

export default FormFeedback;
